import React from 'react';
import { LoginFormRememberMeStyle as S } from './LoginFormRememberMe.style';
import { PFormField } from 'components/prime/PFormField/PFormField';
import { PCheckbox } from 'components/prime/PCheckbox/PCheckbox';
import { useLoginPageBLoC } from 'modules/PublicModule/pages/LoginPage/LoginPage.bloc';

export const LoginFormRememberMe: React.FC = () => {
  const { form } = useLoginPageBLoC();
  return (
    <S.Container>
      <PFormField
        form={form}
        controler={{
          name: 'remember',
        }}
      >
        {({ field }) => (
          <PCheckbox
            {...field}
            onChange={(e) => field.onChange(e.checked)}
            checked={field.value}
            label="Remember me"
            data-testid="checkbox-login-remember-me"
          />
        )}
      </PFormField>
    </S.Container>
  );
};
